import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import { createIssue } from '../../../services/IssueService'

function setErrorMsg(error) {
  return {
    registerError: error.message
  }
}

export default class IssuePageAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {

      issue_uuid: '',
      magazine_id: '',
      magazine_uuid: '',
      owner_id: '',
      tag: '',
      title: '',
      description: '',
      is_publish: '',
      issue_version: '',
      cover_width: '',
      cover_height: '',
      cover_url: '',
      issue_download_url: '',
      download_success_msg_title: '',
      download_success_msg_body: '',
      notify_cover_number: '1:2:3',
      share_text: '',
      embed_html: '',
      date_released: '',
      date_modified: '',
      date_created: '',
      status: '',

      registerError: null,
      currentUser: null,
      isLoading: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();

    log.debug(user.displayName)

    this.setState({currentUser: user})
    this.setState({owner_id: user.uid})
    let uuidv4 = getUUIDV4()
    this.setState({issue_uuid: uuidv4})
    this.setState({magazine_id: this.props.match.params.magazine_id})
    const params = new URLSearchParams(this.props.location.search);
    const magazine_uuid = params.get('magazine_uuid'); // bar
    log.debug(magazine_uuid)
    this.setState({magazine_uuid: magazine_uuid})

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    let issue = {

      issue_uuid: this.state.issue_uuid ,
      magazine_id: this.state.magazine_id ,
      magazine_uuid: this.state.magazine_uuid,
      owner_id: this.state.owner_id ,
      tag: this.state.tag ,
      title: this.state.title ,
      description: this.state.description ,
      is_publish: this.state.is_publish ,
      issue_version: this.state.issue_version ,
      cover_width: this.state.cover_width ,
      cover_height: this.state.cover_height ,
      cover_url: this.state.cover_url ,
      issue_download_url: this.state.issue_download_url ,
      download_success_msg_title: this.state.download_success_msg_title ,
      download_success_msg_body: this.state.download_success_msg_body ,
      notify_cover_number: this.state.notify_cover_number ,
      share_text: this.state.share_text ,
      embed_html: this.state.embed_html ,
      date_released: this.state.date_released ,
      date_modified: this.state.date_modified ,
      date_created: this.state.date_created ,
      status: this.state.status ,
    }
    log.debug(issue)

    try{
      let result = await createIssue(issue)
      log.debug('save success')
      // redirect to list view.
      //this.props.history.push("/issue")
      this.props.history.goBack();
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/issue'>Issue</Link> ->
          Add
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }

          <div className="form-group">
            <label htmlFor="issue_uuid" className="col-sm-2 control-label">issue_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_uuid"
                value={this.state.issue_uuid}
                onChange={this.handleInputChange}
                placeholder="issue_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_id" className="col-sm-2 control-label">magazine_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_id"
                value={this.state.magazine_id}
                onChange={this.handleInputChange}
                placeholder="magazine_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_uuid" className="col-sm-2 control-label">magazine_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_uuid"
                value={this.state.magazine_uuid}
                onChange={this.handleInputChange}
                placeholder="magazine_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="owner_id" className="col-sm-2 control-label">owner_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="owner_id"
                value={this.state.owner_id}
                onChange={this.handleInputChange}
                placeholder="owner_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tag" className="col-sm-2 control-label">tag:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="tag"
                value={this.state.tag}
                onChange={this.handleInputChange}
                placeholder="tag" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="title" className="col-sm-2 control-label">title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
                placeholder="title" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description" className="col-sm-2 control-label">description:</label>
            <div className="col-sm-4">
              <textarea className="form-control"
                //type="text"
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="description" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="is_publish" className="col-sm-2 control-label">is_publish:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="is_publish"
                value={this.state.is_publish}
                onChange={this.handleInputChange}
                placeholder="is_publish" />
            </div>*** [YES || NO]
          </div>
          <div className="form-group">
            <label htmlFor="issue_version" className="col-sm-2 control-label">issue_version:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_version"
                value={this.state.issue_version}
                onChange={this.handleInputChange}
                placeholder="issue_version" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cover_width" className="col-sm-2 control-label">cover_width:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="cover_width"
                value={this.state.cover_width}
                onChange={this.handleInputChange}
                placeholder="cover_width" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cover_height" className="col-sm-2 control-label">cover_height:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="cover_height"
                value={this.state.cover_height}
                onChange={this.handleInputChange}
                placeholder="cover_height" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cover_url" className="col-sm-2 control-label">cover_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="cover_url"
                value={this.state.cover_url}
                onChange={this.handleInputChange}
                placeholder="cover_url" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_download_url" className="col-sm-2 control-label">issue_download_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_download_url"
                value={this.state.issue_download_url}
                onChange={this.handleInputChange}
                placeholder="issue_download_url" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_title" className="col-sm-2 control-label">download_success_msg_title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_title"
                value={this.state.download_success_msg_title}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_title" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_body" className="col-sm-2 control-label">download_success_msg_body:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_body"
                value={this.state.download_success_msg_body}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_body" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="notify_cover_number" className="col-sm-2 control-label">notify_cover_number:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="notify_cover_number"
                value={this.state.notify_cover_number}
                onChange={this.handleInputChange}
                placeholder="notify_cover_number" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="share_text" className="col-sm-2 control-label">share_text:</label>
            <div className="col-sm-4">
              <textarea className="form-control"
                //type="text"
                name="share_text"
                value={this.state.share_text}
                onChange={this.handleInputChange}
                placeholder="share_text" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="embed_html" className="col-sm-2 control-label">embed_html:</label>
            <div className="col-sm-4">
              <textarea className="form-control"
                //type="text"
                name="embed_html"
                value={this.state.embed_html}
                onChange={this.handleInputChange}
                placeholder="embed_html" />
            </div>
          </div>
          {/* <div className="form-group">
            <label htmlFor="date_released" className="col-sm-2 control-label">date_released:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_released"
                value={this.state.date_released}
                onChange={this.handleInputChange}
                placeholder="date_released" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="date_modified" className="col-sm-2 control-label">date_modified:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_modified"
                value={this.state.date_modified}
                onChange={this.handleInputChange}
                placeholder="date_modified" />
            </div>
          </div> */}

          {/* <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_created"
                value={this.state.date_created}
                onChange={this.handleInputChange}
                placeholder="date_created" />
            </div>
          </div> */}

          <div className="form-group">
            <label htmlFor="status" className="col-sm-2 control-label">status:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
                placeholder="status" />
            </div>
          </div>

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Add</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/IssuePage/IssuePageAdd.js